import { OnboardingLayout } from '@/modules/OnboardingWizard';

export default OnboardingLayout;
